module.exports = __webpack_public_path__ + "img/review.625dd80.svg";